import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FeedbackModal } from '@/components/ui/FeedbackModal';
import { cn } from '@/lib/utils';

interface FloatingFeedbackButtonProps {
  className?: string;
}

export function FloatingFeedbackButton({ className }: FloatingFeedbackButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        size="lg"
        className={cn(
          'fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full shadow-lg',
          'hover:scale-105 transition-all duration-200',
          'bg-primary hover:bg-primary/90',
          className
        )}
        aria-label="Send feedback"
      >
        <MessageSquare className="size-6" />
      </Button>

      <FeedbackModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
